import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text } from 'components/ui';
import CompareZoneBase from 'components/Catalog/ProductGrid/CompareModal/Zones/CompareZoneBase';

const IngredientsZone = ({ selectedProducts = [], getText = () => {} }) => {
    const renderContent = () => {
        return (
            <Text
                fontSize='sm'
                color='gray'
            >
                Ingredients Zone
            </Text>
        );
    };

    return (
        <CompareZoneBase
            selectedProducts={selectedProducts}
            getText={getText}
            titleKey='ingredients'
            renderContent={renderContent}
        />
    );
};

IngredientsZone.propTypes = {
    selectedProducts: PropTypes.arrayOf(PropTypes.object),
    getText: PropTypes.func
};

export default wrapFunctionalComponent(IngredientsZone, 'IngredientsZone');
